import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PcpCommandBarComponent } from './pcp-commandbar.component';
import { CommandButtonComponent } from './commandbutton/commandbutton.component';
import { CommandBarLeftDirective } from './commandbar-left.directive';
import { CommandBarRightDirective } from './commandbar-right.directive';

@NgModule({
    imports: [
        CommonModule,
        PcpCommandBarComponent, CommandButtonComponent, CommandBarLeftDirective, CommandBarRightDirective
    ],
    exports: [PcpCommandBarComponent, CommandButtonComponent, CommandBarLeftDirective, CommandBarRightDirective]
})
export class PcpCommandBarModule { }
